// extracted by mini-css-extract-plugin
export default {"btn":"Fav_btn__eWyy6","btns":"Fav_btns__FPG0-"};